import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/pim/product-icons/not_deliverable.png'
import _imports_1 from '@/assets/images/pim/product-icons/image_available.png'
import _imports_2 from '@/assets/images/pim/product-icons/prescription.png'
import _imports_3 from '@/assets/images/pim/product-icons/written_request.png'
import _imports_4 from '@/assets/images/pim/product-icons/medicine.png'
import _imports_5 from '@/assets/images/pim/product-icons/medical_aid.png'


const _withScopeId = n => (_pushScopeId("data-v-44b29c3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fs-5 mb-0" }
const _hoisted_2 = {
  key: 0,
  class: "legend-item d-flex align-items-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "not deliverable"
}, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "legend-item d-flex align-items-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "multi image"
}, null, -1))
const _hoisted_6 = { class: "legend-item d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "prescription"
}, null, -1))
const _hoisted_8 = { class: "legend-item d-flex align-items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "written request"
}, null, -1))
const _hoisted_10 = { class: "legend-item d-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "medicine"
}, null, -1))
const _hoisted_12 = { class: "legend-item d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "medicinal aid"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_card_header = _resolveComponent("base-card-header")!
  const _component_base_card_body = _resolveComponent("base-card-body")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, { class: "legend" }, {
    default: _withCtx(() => [
      _createVNode(_component_base_card_header, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('legend')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_base_card_body, null, {
        default: _withCtx(() => [
          (!_ctx.isForPharmacist)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('productNoLongerDeliverable')), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isForPharmacist)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('imageAvailable')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('onPrescription')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('onWrittenRequest')), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('registeredMedicine')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('registeredMedicalAid')), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}